const fbRegisterLogEvent = (eventName, params) => {
  if (process.env.NODE_ENV === 'production') {
    window.FB.AppEvents.logEvent(eventName, null, params)
  } else {
    console.log({ env: process.env.NODE_ENV, eventName, params })
  }
}

export default fbRegisterLogEvent
